var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-form-select', {
    class: _vm.filterClass,
    attrs: {
      "show-labels": false,
      "id": _vm.id,
      "disabled": _vm.disable,
      "value-field": _vm.trackBy,
      "text-field": _vm.titleBy,
      "options": _vm.options,
      "multiple": _vm.multiple,
      "required": _vm.isRequired
    },
    model: {
      value: _vm.selected,
      callback: function ($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  }, [_c('template', {
    slot: "first"
  }, [_c('b-form-select-option', {
    attrs: {
      "value": null,
      "disabled": ""
    }
  }, [_vm._v("\n      -- Please select an option --\n    ")])], 1)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }